// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as UnauthenticatedTemplate from "./UnauthenticatedTemplate.bs.jsx";

function ForgottenPasswordSent(props) {
  let onGoBack = props.onGoBack;
  return <UnauthenticatedTemplate.make>
    <h2>
      {"Zapomenuté heslo"}
    </h2>
    <p>
      {`Poslali jsme vám odkaz na změnu hesla. Zkontrolujte poštu na adrese `}
      <b>
        {props.email}
      </b>
    </p>
    <button
      className={Styles.button.base}
      type={"button"}
      onClick={param => onGoBack()}
    >
      {`Zpět na přihlášení`}
    </button>
  </UnauthenticatedTemplate.make>;
}

let make = ForgottenPasswordSent;

export {
  make,
}
/* Styles Not a pure module */
